import { currentHeaderHeight } from '@modules/header/header.js'
import { slideTo } from '@utils/animation.js'
import { trackEvent } from '../../modules/tracking/tracking'
import { overlayScroll } from '../../utils/overlay'

const QUICK_LINKS_CLASSES = [
    'js-sticky-nav',
    'tw-fixed',
    'tw-top-[var(--header-height)]',
    'tw-w-full',
    'tw-left-0',
    'tw-px-4',
    'tw-py-2',
    'tw-bg-white',
    'tw-z-10',
    'tw-mt-0.5',
    'tw-shadow',
    'tw-transition-transform',
    'tw-duration-300',
    '[&.is-hidden]:tw-opacity-0',
    '[&.is-hidden]:tw-pointer-events-none',
    '[&.is-hidden]:-tw-translate-y-full',
]
export const initStickyQuickLinks = () => {
    // if (window.matchMedia('(min-width: 768px)').matches) {
    //     return
    // }

    const quickLinks = document.querySelector('[data-article-quick-links]')
    const quickLinksAnchors = document.querySelectorAll('[data-article-quick-links] a')
    const elementTitles = document.querySelectorAll('[data-progress-title]')

    if (!quickLinks || !elementTitles.length) {
        console.warn('Required elements for sticky quick links not found')
        return
    }

    const handleAnchorClick = async (anchor) => {
        const href = anchor.getAttribute('href')
        if (!href) return

        isScrollingProgrammatically = true

        updateActiveAnchor(anchor.hash.replace(/^#/, ''))

        try {
            trackEvent('quick_link_click', {
                label: anchor.textContent.trim(),
            })

            await slideTo(href, -1 * currentHeaderHeight(true))
        } catch (error) {
            console.error('Error scrolling to anchor:', error)
        } finally {
            setTimeout(() => {
                isScrollingProgrammatically = false
            }, 100)
        }
    }

    quickLinksAnchors.forEach((anchor, index) => {
        anchor.addEventListener('click', async (event) => {
            event.preventDefault()
            await handleAnchorClick(anchor, index)
        })
    })

    const floatingQuickLinks = quickLinks.cloneNode(true)
    floatingQuickLinks.classList.add('is-hidden')
    floatingQuickLinks.classList.add(...QUICK_LINKS_CLASSES)

    const floatingQuickLinksAnchors = floatingQuickLinks.querySelectorAll('a')

    let didMoveAnchors = false

    floatingQuickLinksAnchors.forEach((anchor, index) => {
        anchor.addEventListener('click', (event) => {
            event.preventDefault()
            if (!didMoveAnchors) {
                handleAnchorClick(anchor, index)
            }
        })
    })

    quickLinks.parentNode.insertBefore(floatingQuickLinks, quickLinks)

    const scrollElement = floatingQuickLinks?.querySelector('[data-scroll-fade-overlay]')

    if (!scrollElement) {
        console.warn('Scroll element not found')
        return
    }

    const hasTouchEvents = 'ontouchstart' in window

    overlayScroll(scrollElement, '10%')

    if (!hasTouchEvents) {
        // On desktop, allow dragging the scroll element

        scrollElement.style.overflow = 'hidden'
        scrollElement.style.flexWrap = 'nowrap'
        scrollElement.style.userSelect = 'none'
        scrollElement.style.cursor = 'grab'
        scrollElement.style['-webkit-user-drag'] = 'none'

        let dragOffset = 0
        let dragStart = null
        let isDragging = false

        const handleMouseMove = (event) => {
            if (!isDragging) return
            event.preventDefault()
            scrollElement.scrollLeft = dragOffset - event.clientX

            if (Math.abs(dragStart - event.clientX) > 5) {
                didMoveAnchors = true
            }
        }

        const handleMouseUp = () => {
            isDragging = false
            scrollElement.style.cursor = 'grab'
            document.removeEventListener('mousemove', handleMouseMove)
            document.removeEventListener('mouseup', handleMouseUp)
        }

        scrollElement.addEventListener('mousedown', (event) => {
            event.preventDefault()
            didMoveAnchors = false
            isDragging = true
            dragOffset = event.clientX + scrollElement.scrollLeft
            dragStart = event.clientX
            scrollElement.style.cursor = 'grabbing'
            document.addEventListener('mousemove', handleMouseMove)
            document.addEventListener('mouseup', handleMouseUp)
        })

        scrollElement.addEventListener('mouseleave', () => {
            if (isDragging) {
                handleMouseUp()
            }
        })
    }

    let isScrollingProgrammatically = false
    let scrollTimeout = null

    const quickLinksRect = quickLinks.getBoundingClientRect()
    let quickLinksOriginalTop = quickLinksRect.top + (window.scrollY || window.pageYOffset)

    let currentActiveAnchor = null
    const updateActiveAnchor = (id) => {
        if (currentActiveAnchor === id) {
            return
        }
        currentActiveAnchor = id

        const index =
            id === null
                ? -1
                : Array.from(floatingQuickLinksAnchors).findIndex((anchor) => {
                      return anchor.hash.replace(/^#/, '') === id.replace(/^#/, '')
                  })

        if (index !== -1 && floatingQuickLinks.classList.contains('is-hidden')) {
            floatingQuickLinks.classList.remove('is-hidden')
        } else if (index === -1 && !floatingQuickLinks.classList.contains('is-hidden')) {
            floatingQuickLinks.classList.add('is-hidden')
        }

        floatingQuickLinksAnchors.forEach((anchor, i) => {
            if (i === index && anchor) {
                const anchorRect = anchor.getBoundingClientRect()
                const wrapperRect = floatingQuickLinks.getBoundingClientRect()
                const scrollLeft = scrollElement.scrollLeft

                let scrollAmount = null
                if (wrapperRect.width > 768) {
                    const edgeMargin = wrapperRect.width * 0.1

                    if (anchorRect.right > wrapperRect.right - edgeMargin) {
                        scrollAmount = Math.max(
                            0,
                            scrollLeft + (anchorRect.right - wrapperRect.right) + edgeMargin,
                        )
                    } else if (anchorRect.left < wrapperRect.left + edgeMargin) {
                        scrollAmount = Math.max(
                            0,
                            scrollLeft - (wrapperRect.left - anchorRect.left) - edgeMargin,
                        )
                    }
                } else {
                    scrollAmount = Math.max(
                        0,
                        anchorRect.left + scrollLeft - wrapperRect.width / 2 + anchorRect.width / 2,
                    )
                }

                if (scrollAmount !== null) {
                    window.requestAnimationFrame(() => {
                        scrollElement.scrollTo({
                            left: scrollAmount,
                            behavior: 'smooth',
                        })
                    })
                }

                anchor.classList.add(
                    '!tw-text-white',
                    '!tw-bg-dark-blue-500',
                    '!tw-border-dark-blue-500',
                )
            } else {
                anchor.classList.remove(
                    '!tw-text-white',
                    '!tw-bg-dark-blue-500',
                    '!tw-border-dark-blue-500',
                )
            }
        })
    }

    const handleScroll = () => {
        if (isScrollingProgrammatically) {
            return
        }
        if (scrollTimeout) {
            window.clearTimeout(scrollTimeout)
        }

        scrollTimeout = setTimeout(() => {
            const currentScroll = window.scrollY || window.pageYOffset
            const headerHeight = currentHeaderHeight(true)

            // Check if we've scrolled past the original position of quick links
            const shouldStick = currentScroll > quickLinksOriginalTop

            if (shouldStick) {
                if (floatingQuickLinks.classList.contains('is-hidden')) {
                    floatingQuickLinks.classList.remove('is-hidden')
                }

                if (!isScrollingProgrammatically) {
                    const activeElementTitle = Array.from(elementTitles)
                        .reverse()
                        .find((title) => {
                            const bounds = title.getBoundingClientRect()
                            return bounds.y - headerHeight < 1
                        })
                    if (activeElementTitle) {
                        updateActiveAnchor(activeElementTitle.id)
                    }
                }
            } else {
                floatingQuickLinks.classList.add('is-hidden')

                updateActiveAnchor(null)
            }

            scrollTimeout = null
        }, 16)
    }

    // Store the original position after any dynamic content loads
    setTimeout(() => {
        quickLinksOriginalTop =
            quickLinks.getBoundingClientRect().top + (window.scrollY || window.pageYOffset)
    }, 0)

    window.addEventListener('scroll', handleScroll, { passive: true })

    // Update original position on resize
    const resizeObserver = new ResizeObserver(() => {
        if (!quickLinks.classList.contains('js-sticky-nav')) {
            quickLinksOriginalTop =
                quickLinks.getBoundingClientRect().top + (window.scrollY || window.pageYOffset)
        }
    })

    resizeObserver.observe(quickLinks)

    return () => {
        window.removeEventListener('scroll', handleScroll)
        resizeObserver.disconnect()
        if (scrollTimeout) {
            clearTimeout(scrollTimeout)
        }
    }
}
